import GridAction from '../../components/common/GridAction';
import { AppPermissions } from '../../constants/Permissions';
import { TranslationItem } from '../../types/Language';

export const makeManageLanguagelabelsColumn = (
  onEdit: (language: TranslationItem) => void,
  onDelete: (isoCode: string, label: string) => void,
  isoCode: string
) => {
  const col = [
    {
      header: 'Actions',
      accessorKey: 'actions',
      sortable: false,
      size: 55,
      cell: ({ row }) => {
        return (
          <GridAction
            onEdit={() => onEdit(row.original)}
            editPermission={AppPermissions.Language.Manage}
            onDeleted={() => onDelete(isoCode, row.original.name)}
            deletePermission={AppPermissions.Language.Manage}
            row={row.original}
            id={row.original.name}
          />
        );
      },
    },
    {
      header: 'Label Key',
      accessorKey: 'name',
      enableColumnFilter: true,
      size: 350,
    },
    {
      header: 'Label Value',
      accessorKey: 'value',
      enableColumnFilter: true,
      size: 300,
    },
  ] as Array<any>;

  return col;
};
